import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const STATUSES = {
  new: { label: "Eingegangen", cls: "bg-[#EFDF00] text-black" },
  confirmed: { label: "Bestätigt", cls: "bg-green-100 text-green-800" },
  done: { label: "Erledigt", cls: "bg-blue-100 text-blue-800" },
  cancelled: { label: "Abgesagt", cls: "bg-red-100 text-red-700" },
};

export const contactStatus = (c) => {
  if (c.status === "cancelled") return "cancelled";
  if (c.callback_done || c.status === "done" || c.status === "replied") return "done";
  return c.status === "confirmed" ? "confirmed" : "new";
};

export const ContactStatusControl = ({ contact, headers, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const current = contactStatus(contact);

  const change = async (status) => {
    if (status === current) return;
    const mail = contact.email ? ` Der Kunde (${contact.email}) bekommt eine E-Mail.` : "";
    if (!window.confirm(`Status auf „${STATUSES[status].label}“ setzen?${mail}`)) return;
    setBusy(true);
    try {
      const r = await axios.put(`${API}/contacts/${contact.id}/status`, { status }, headers);
      toast.success(r.data.message);
      onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Status konnte nicht geändert werden");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Select value={current} onValueChange={change} disabled={busy}>
      <SelectTrigger className={`h-8 w-36 border-0 text-xs font-bold ${STATUSES[current].cls}`} data-testid={`contact-status-${contact.id}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(STATUSES).map(([k, v]) => (
          <SelectItem key={k} value={k} data-testid={`contact-status-option-${k}`}>{v.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
